import * as _ from 'lodash'
import React, { useState } from 'react';
import * as vendorActions from '../vendorActions';import componentServices from '../componentServices';
import { useJobCostItemDragDrop } from '../draggableJobCostLineItem';
import valueFilters from '../valueFilters';
import util from '../util';
import keyboardUtil from 'Scripts/keyboardUtils';
import enums from '../enum';
import { CurrencyInput, Header, jobCostRowOwner, JobCostHiddenWhenLocked, NumericInput } from './sharedComponents';
import { getCollection, ModelCollection } from 'Scripts/store';

const _jobCostLineItemTypes = [{ name: 'cabinet' }];
const KEY_DOWN_CODES = [13];

const JobCostCabinetRow = function(props) {
	const { store } = componentServices;
	const { alwaysValidate, buttonHandler, classNames = [], buttonClass, draggable, dropLineItem, lineItem, updateModel, workAreas } = props;
	const [shouldValidate, setShouldValidate] = useState(alwaysValidate);
	const [{isDragging, dragSourceRef, dragPreviewRef, dropItem, dropTargetRef, rowRef}] = useJobCostItemDragDrop({ 
		item: lineItem,
		handleDrop: (dragItem, dropItem) => dropLineItem(dragItem.key, dropItem.key) 
	});

	function handleUpdate (path, autoSave, e) {
		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		updateModel((model, updateCallback) => {
			model.setAt(path, newVal);

			updateCallback(model, path);
		}, { autoSave: autoSave });
	}

	function convertCostFactor (val) {
		const valParts = val.split(':');

		return valueFilters.cleanNumber(valParts[valParts.length - 1]) || '';
	}

	function validate (property?) {
		if (!property || shouldValidate) {
			const result = !lineItem.test(property);

			return result;
		}
		return true;
	}

	function handleButtonClick (e) {
		e.preventDefault();

		const valid = validate();

		if (!valid) {
			setShouldValidate(true);
		}
		else {
			// this assumes that the add handler succeeds
			setShouldValidate(alwaysValidate);
		}

		buttonHandler(valid, e);
	}

	let dropClass:any = undefined;
	const dragClass = isDragging ? 'disabled' : null;

	if (dropItem) {
		const dropIndex = lineItem.sortIndex;
		const dragIndex = dropItem.sortIndex;

		dropClass = (dropIndex > dragIndex) ? 'dropBottom' : 'dropTop';
	}

	const rowClasses = _.concat(classNames, dropClass, dragClass);
	const workAreaOptions:JSX.Element[] = [];

	workAreaOptions.push(<option key="unknown" value="">Select</option>);
	_.forEach(workAreas, workArea => {
		workAreaOptions.push(<option key={workArea.key} value={workArea.key}>{workArea.name}</option>);
	});

	const vendors = getCollection({ store, collection: ModelCollection.vendors }).filter(v => {
		return v.type === enums.vendorTypes.Cabinet_Supplier;
	}).sortBy(v => v.name);
	const vendor = lineItem.vendorKey && vendors.find(v => v.key === lineItem.vendorKey);
	const vendorOptions:JSX.Element[] = [];
	vendorOptions.push(<option key="unknown" value="">Select</option>);
	vendors.forEach(v => {
		vendorOptions.push(<option key={v.key} value={v.key}>{v.name}</option>);
	});

	return <tr ref={ rowRef } className={rowClasses.join(' ')}>
		<td />
		<td className={ !validate('vendorKey') ? 'required' : '' }>
			<select placeholder="Select" value={lineItem.viewValue('workAreaKey')} onChange={e => handleUpdate('workAreaKey', true, e)}>
				{ workAreaOptions }
			</select>
		</td>
		<td className={ !validate('vendorKey') ? 'required' : '' }>
			<select placeholder="Select" value={lineItem.viewValue('vendorKey')} onChange={e => handleUpdate('vendorKey', true, e)}>
				{ vendorOptions }
			</select>
		</td>
		<td className={' ' + (!validate('description') ? 'required' : '')}>
			<input type="text" placeholder="Enter" autoCapitalize="" autoCorrect="off" 
				value={lineItem.viewValue('description')} 
				onChange={e => handleUpdate('description', false, e)} 
				onBlur={e => handleUpdate('description', true, e)} 
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
		</td>
		<td className={'list ' + ' ' + (!validate('listPrice') ? 'required' : '')}>
			<CurrencyInput placeholder="0.00" value={lineItem.viewValue('listPrice')} 
				onChange={e => handleUpdate('listPrice', false, e)} 
				onBlur={e => handleUpdate('listPrice', true, e)}
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
		</td>
		<td className={'factor ' + ' ' + (!validate('costFactor') ? 'required' : '')}>
			<NumericInput placeholder="0.00" value={lineItem.viewValue('costFactor')} 
				dataListOptions={ vendor && _.map(vendor.costFactors, f => <option key={f.description}>{ `${f.description}: ${f.value}` }</option>) } 
				dataListKey={ vendor && `cf_${lineItem.key}`} valueConverter={ convertCostFactor } 
				onChange={e => handleUpdate('costFactor', false, e)} 
				onBlur={e => handleUpdate('costFactor', true, e)}
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
		</td>
		<td className={'cost ' + ' ' + (!validate('cost') ? 'required' : '')}>
			<CurrencyInput placeholder="0.00" value={lineItem.viewValue('cost')} 
				onChange={e => handleUpdate('cost', false, e)} 
				onBlur={e => handleUpdate('cost', true, e)}
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
		</td>
		<td className={'freight ' + ' ' + (!validate('freight') ? 'required' : '')}>
			<CurrencyInput placeholder="0.00" value={lineItem.viewValue('freight')} 
				onChange={e => handleUpdate('freight', false, e)} 
				onBlur={e => handleUpdate('freight', true, e)}
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
		</td>
		<td className={'sell ' + ' ' + (!validate('sellPrice') ? 'required' : '')}>
			<CurrencyInput placeholder="0.00" value={lineItem.viewValue('sellPrice')} 
				onChange={e => handleUpdate('sellPrice', false, e)} 
				onBlur={e => handleUpdate('sellPrice', true, e)}
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
		</td>
		<td><button className={buttonClass} onClick={handleButtonClick}><span /></button></td>
		<td />
	</tr>;
}

const JobCostCabinetSection = jobCostRowOwner({ listAccessor: model => model.lineItems, listFilterThunkFactory: props => row => row.type === props.type }, class CabinetSection extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(props);

		this.dropLineItem = this.dropLineItem.bind(this);
	}

	componentDidMount () {
		vendorActions.fetchCabinetSuppliers();
	}

	getStateFromProps (props) {
		const state = _.assign({}, this.state);

		if (!state.pendingLineItem || state.pendingLineItem.type !== props.type) {
			state.pendingLineItem = this.createPendingLineItem(props);
		}

		return state;
	}

	addLineItemHandler (lineItemKey, isValid) {
		if (!isValid) {
			return;
		}

		this.props.updateModel(model => {
			if (lineItemKey === this.state.pendingLineItem.key) {
				this.state.pendingLineItem.sortIndex = this.props.getNextSortIndex(model);
				model.lineItems.add(this.state.pendingLineItem);

				this.props.sortRows(model);

				this.setState({ pendingLineItem: this.createPendingLineItem(this.props) });
			}
		}, { autoSave: true });
	}

	createPendingLineItem (props) {
		const { jobCost, type } = props;
		return jobCost.createLineItem({ type: type, margin: jobCost.margin });
	}

	printHandler () {
		// empty
	}

	updateModel (key, updater, options) {
		this.props.updateModel((jobCost, lineUpdateCallback) => {
			let lineItem = jobCost.lineItems.get(key);

			if ((!lineItem) && (key === this.state.pendingLineItem.key)) {
				lineItem = this.state.pendingLineItem;
				options.autoSave = false;
			}

			if (lineItem) {
				const originalWorkAreaKey = lineItem.workAreaKey;

				updater(lineItem, lineUpdateCallback);

				const updatedItem = _.find(jobCost.lineItems, { rootKey: lineItem.rootKey }) || lineItem; // if this is a change order then we likely have a new item entity, get the correct entity for this side-effect

				if (updatedItem.workAreaKey !== originalWorkAreaKey) {
					const selectedWorkArea = _.find(jobCost.workAreas, { key: updatedItem.workAreaKey });

					if (selectedWorkArea) {
						updatedItem.vendorKey = selectedWorkArea.vendorKey;
					}
				}
			}
		}, options);
	}

	dropLineItem (sourceKey, targetKey) {
		this.props.updateModel(jobCost => {
			const sourceItem = jobCost.lineItems.get(sourceKey);
			const targetItem = jobCost.lineItems.get(targetKey);

			this.props.handleItemDrop(jobCost, sourceItem, targetItem);
		}, { autoSave: true });
	}

	render () {
		const { getRowClasses, jobCost, summary, type, rowContextMenuHandler } = this.props;
		const lineItems = _.map(_.sortBy(jobCost.getLineItemsByType(type), 'sortIndex'), item => {
			return (
				<JobCostCabinetRow key={item.rowKey} updateModel={this.updateModel.bind(this, item.key)} dropLineItem={ this.dropLineItem } buttonHandler={ rowContextMenuHandler.bind(this, item) } lineItem={item} classNames={ getRowClasses({ item: item }) } buttonClass="icon iconOnly contextMenu" draggable={true} workAreas={jobCost.workAreas} alwaysValidate={true}/>
			);
		});
		const taxCost = summary.calculatePreSubtotalTaxCost('order', 'cabinet');

		return (
			<section>
				<header />
				<div className="inner">

					<table className="compact" cellPadding="0" cellSpacing="0">
						<thead>
							<tr>
								<td />
								<td><span className="readOnly">Work Area</span></td>
								<td><span className="readOnly">Supplier</span></td>
								<td><span className="readOnly">Description</span></td>
								<td className="list"><span className="readOnly">List</span></td>
								<td className="factor"><span className="readOnly">Factor</span></td>
								<td className="cost"><span className="readOnly">Cost</span></td>
								<td className="freight"><span className="readOnly">Freight</span></td>
								<td className="sell"><span className="readOnly">Sell</span></td>
								<td className="action" />
								<td />
							</tr>
						</thead>
						<tbody>
							<JobCostHiddenWhenLocked jobCost={ jobCost }><JobCostCabinetRow key={this.state.pendingLineItem.key} updateModel={this.updateModel.bind(this, this.state.pendingLineItem.key)} buttonHandler={this.addLineItemHandler.bind(this, this.state.pendingLineItem.key)} lineItem={this.state.pendingLineItem} classNames={ ['addRow'] } buttonClass="icon iconOnly addItem" draggable={false} workAreas={jobCost.workAreas}/></JobCostHiddenWhenLocked>
							{ lineItems }
						</tbody>
						<tfoot className="subtotal">
							{ taxCost ? <tr>
								<td />
								<td className="right" colSpan={ 5 }>{_.startCase(type)} Tax Cost</td>
								<td className="cost" colSpan={ 2 }>{util.formatAsCurrency(taxCost)}</td>
								<td />
								<td />
							</tr> : null
							}
							<tr>
								<td />
								<td className="right" colSpan={ 5 }>{_.startCase(type)} Subtotal</td>
								<td className="cost" colSpan={ 2 }>{util.formatAsCurrency(summary.orderCabinetSell)}</td>
								<td />
								<td />
							</tr>
						</tfoot>
					</table>
				</div>
			</section>
		);
	}
});

export default ({ jobCost = undefined, summary = undefined, updateModel = undefined }) => {
	const sections = _.map(_jobCostLineItemTypes, type => {
		return (
			<JobCostCabinetSection key={type.name} updateModel={updateModel} jobCost={jobCost} summary={ summary } type={type.name} />
		);
	});

	return (
		<section>
			<Header title="Cabinet Cost"/>
			<div>
				{sections}
			</div>
		</section>

	);
};
